// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Mj5T","tab":"ProcedureTabs_tab__1E5p6"};